module.exports = __webpack_public_path__ + "img/bucu_3kl.960ea1f3.jpg";